import { reactive } from 'vue';
import capacitorService from '../capacitor/capacitor.service';

// TODO: #62 Replace this with VueX.
export default reactive({
  devMode: null,
  apiUrl: null,
  isCapacitor: null,
});
